import { ImprovedParticipantShop } from "../../../Interfaces/FundraiserRole";
import participant from "./Participants";
import fundraiser from "./Fundraiser";
import sku_by_category from "./SkuByCategory";
import designs from "./Designs";
import products from "./Products";
import clothing_sizes from "./ClothingSizes";
import recommendations_by_sku from "./RecomendationsBySku";

export const static_participant_shop_data: ImprovedParticipantShop = {
  participant: participant,
  fundraiser: fundraiser,
  products: products,
  sku_by_category: sku_by_category,
  recommendations_by_sku: recommendations_by_sku,
  designs: designs,
  clothing_sizes: clothing_sizes,
};
